import { useEffect } from "react";

export interface WymhSeoConfig {
  title: string;
  description?: string;
  keywords?: string;
  canonical?: string;
}

function upsertMeta(selector: string, attrName: string, attrValue: string, content?: string) {
  const head = document.head;
  if (!content) {
    const existing = head.querySelector(selector);
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }
    return;
  }
  let el = head.querySelector(selector) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attrName, attrValue);
    head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * 按页面设置标题、描述、关键词与 canonical。
 * 传空字符串或不传时，会移除对应的 description / keywords 标签。
 */
export function useWymhSeo(config: WymhSeoConfig) {
  const { title, description, keywords, canonical } = config;

  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMeta('meta[property="og:title"]', "property", "og:title", title);
    }
    upsertMeta('meta[name="description"]', "name", "description", description);
    upsertMeta('meta[name="keywords"]', "name", "keywords", keywords);
    upsertMeta('meta[property="og:description"]', "property", "og:description", description);

    if (canonical) {
      let link = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = canonical;
    }
  }, [title, description, keywords, canonical]);
}

export default useWymhSeo;